import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { theme } from 'coreOld/themes';
import { FieldError } from 'react-hook-form';

interface IconProps {
  endIcon?: boolean;
  children?: ReactNode;
  onClick?: any;
}

interface InputProps {
  textAlign?: string;
  hasBorder?: boolean;
  fontInherit?: boolean;
  isDisabledState?: boolean;
  disabled?: boolean;
  size?: string;
  hasIcon?: boolean;
  error?: string | FieldError;
  value?: any;
  onChange?: any;
  defaultValue?: any;
  type?: string;
  autoFocus?: boolean;
  onBlur?: any;
  onKeyDown?: any;
  placeholder?: string;
  name?: string;
  id?: string;
  min?: any;
  max?: any;
  step?: any;
}

const getBorderColor = (hasBorder = true) => {
  if (!hasBorder) {
    return `
      border: 1px solid ${theme.palette.neutral.light};
    `;
  }

  return `
    border: 1px solid ${theme.palette.borderColor};
  `;
};

const getHoverBorderColor = (theme, isDisabledState = false, hasBorder = true, error = false) => {
  if (isDisabledState) {
    return `
      border: none;
      `;
  }

  const borderColor = error
    ? theme.colors.dangerBtn
    : hasBorder
    ? theme.palette.hover.borderColor
    : theme.palette.hover.main;

  return `
    border: 1px solid ${borderColor} !important;
    `;
};

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const Icon = styled.span<IconProps>`
  position: absolute;
  top: 56%;
  transform: translateY(-60%);
  margin-left: 15px;

  ${({ endIcon }) =>
    endIcon &&
    css`
      transform: translateY(-60%);
      margin-left: -35px;
    `}

  &:hover {
    cursor: pointer;
  }
`;

export const Input = styled.input<InputProps>`
  background-color: ${({ theme }) => theme.palette.backgrounds.main};
  color: ${({ theme }) => theme.palette.neutral.darkest};
  font:
    400 12px 'Open Sans',
    sans-serif;
  background-clip: padding-box;
  box-shadow: none;
  background-image: none;
  height: 38px;
  width: 100%;
  border-radius: 0;
  line-height: 1.25;
  padding: 3px 10px;
  text-align: ${({ textAlign }) => textAlign || 'left'};

  ${({ hasBorder }) => css`
    ${getBorderColor(hasBorder)}
  `}

  &::placeholder {
    color: ${({ theme }) => theme.palette.text.placeholder};
  }

  ${({ fontInherit }) =>
    fontInherit &&
    css`
      font-size: inherit;
      font-weight: inherit;
    `}

  ${({ isDisabledState, disabled }) =>
    (isDisabledState || disabled) &&
    css`
      border: none;
      cursor: not-allowed;
      opacity: 0.5;
      font-size: inherit;

      &:focus,
      &:hover {
        border: none;
      }
    `}

  ${({ size }) =>
    size &&
    css`
      height: ${({ theme }) => theme.inputHeight[size]};
    `}

  ${({ hasIcon }) =>
    hasIcon &&
    css`
      padding: 3px 20px;
      padding-left: 50px;
    `}

    ${({ error }) =>
    error &&
    css`
      border: 1px solid ${({ theme }) => theme.colors.dangerBtn};
    `}

  &:focus, &:hover {
    outline: none;

    ${({ theme, isDisabledState, disabled, hasBorder, error }) => css`
      ${getHoverBorderColor(theme, isDisabledState || disabled, hasBorder, Boolean(error))}
    `}
  }
`;

export const InputWrapper = styled.div`
  width: 100%;
`;

export const Div = styled.div`
  margin-bottom: 5px;
  margin-top: 5px;
`;
